import create, { SetState, StateCreator, StoreApi } from "zustand";

interface DynamicFormStore {
  originalFields: any;
  setOriginalFields: (x: any) => void;
  modifiedFields: any;
  setModifiedFields: (x: any) => void;
  isInvalidFlag: any;
  setIsInvalidFlag: (x: any) => void;
  tags: { [fieldId: string]: string[] };
  setTags: (fieldId: string, tags: string[]) => void;
  clearStore: () => void;
}

let store: StateCreator<DynamicFormStore, [], [], DynamicFormStore> | StoreApi<DynamicFormStore> = (set: SetState<DynamicFormStore>) => ({
  originalFields: [],
  setOriginalFields: (x) => {
    set(() => ({ originalFields: x }));
  },
  modifiedFields: [],
  setModifiedFields: (x) => {
    set(() => ({ modifiedFields: x }));
  },
  isInvalidFlag: false,
  setIsInvalidFlag: (x) => {
    set(() => ({ isInvalidFlag: x }));
  },
  tags: {},
  setTags: (fieldId, tags) => {
    set((state) => ({ tags: { ...state.tags, [fieldId]: tags } }));
  },
  clearStore: () => {
    set(() => ({ originalFields: [], modifiedFields: [], isInvalidFlag: false, tags: {} }));
  },
});

export const useDynamicFormStore = create(store);
